import { STOCK_STATUSES, TEST_VERSION } from '/src/consts';

const jsonSchemaProduct = ({
    storeConfig: {
        product_url_suffix
    },
    product: {
        url_key,
        name,
        sku,
        url,
        stock_status,
        value,
        currency,
        short_description,
        ingredients,
        country_of_origin_value,
        trustpilot_aggregate_rating,
        trustpilot_reviews,
    },
    getTestVersion,
    breadcrumbs,
}) => {
    const { review_count, rating_value } = trustpilot_aggregate_rating || {};
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'product-ld-json');

    const aggregateRating = !!review_count
        ? { "@type": "AggregateRating", "reviewCount": review_count, "ratingValue": rating_value }
        : undefined;

    const review = !!trustpilot_reviews?.length
        ?
            trustpilot_reviews.map(({
                review_body,
                date_published,
                author_name,
                rating_value,
            }) => ({
                "@type": "Review",
                "reviewBody": review_body,
                "author": {
                    "@type": "Person",
                    "name": author_name,
                },
                "datePublished": date_published,
                "reviewRating":{
                    "@type": "Rating",
                    "ratingValue": rating_value
                },
            }))
        : undefined;


    if (getTestVersion([TEST_VERSION.A, TEST_VERSION.B])) {
        script.innerHTML = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            "name": name,
            "sku": sku,
            "image": url,
            "url": `${process.env.HOST_URL}/${url_key}${product_url_suffix}`,
            "description": short_description.html.replace(/<\/?[^>]+(>|$)/g, '').replace(/[\r\n]+/gm, ' '),
            "aggregateRating": aggregateRating,
            "review": review,
            "offers": {
                '@type': 'Offer',
                'availability': stock_status === STOCK_STATUSES.IN_STOCK ? 'InStock' : 'OutOfStock',
                'price': value,
                'priceCurrency': currency,
            },
        });
    }

    if (getTestVersion([TEST_VERSION.C, TEST_VERSION.D])) {
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "Product",
                    "@id": `${process.env.HOST_URL}/${url_key}${product_url_suffix}`,
                    "name": name,
                    "url": `${process.env.HOST_URL}/${url_key}${product_url_suffix}`,
                    "image": [url],
                    "sku": sku,
                    "description": short_description.html.replace(/<\/?[^>]+(>|$)/g, '').replace(/[\r\n]+/gm, ' '),
                    "aggregateRating": aggregateRating,
                    "review": review,
                    "offers": [{
                        "@type": "Offer",
                        "url": `${process.env.HOST_URL}/${url_key}${product_url_suffix}`,
                        "price": value,
                        "priceCurrency": currency,
                        "availability": stock_status === STOCK_STATUSES.IN_STOCK ? 'InStock' : 'OutOfStock',
                        "itemCondition": "https://schema.org/NewCondition",
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": value,
                            "priceCurrency": currency,
                            "referenceQuantity": {
                                "@type": "QuantitativeValue",
                                "value": 1.0,
                            }
                        },
                        "hasMerchantReturnPolicy": {
                            "@type": "MerchantReturnPolicy",
                            "applicableCountry": currency,
                            "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                            "merchantReturnDays": 30,
                            "returnMethod": "https://schema.org/ReturnByMail",
                            "returnFees": "https://schema.org/ReturnFeesCustomerResponsibility"
                        }
                    }],
                    "brand": {
                        "@type": "Brand",
                        "name": "Buy Whole Foods Online"
                    },
                    "countryOfOrigin": country_of_origin_value,
                    "category": breadcrumbs?.map(({ name }) => name).join(' > '),
                    "size": {
                        "@type": "QuantitativeValue",
                        "value": 1.0,
                    },
                    "additionalProperty": !!ingredients ? [{ "@type": "PropertyValue", "name": "Ingredients", "value": ingredients }] : [],
                },
                {
                    "@type": "BreadcrumbList",
                    "@id": `${process.env.HOST_URL}/${url_key}${product_url_suffix}`,
                    "itemListElement": breadcrumbs?.map(({ name, url }, index) => ({
                        "@type": "ListItem",
                        "position": index + 1,
                        "name": name,
                        "item": `${process.env.HOST_URL}/${url}`,
                    })),
                }
            ],
        });
    }

    document.head.appendChild(script)
};

const jsonSchemaProductRemove = () => {
    const recipeScript = document.getElementById('product-ld-json');

    if (recipeScript) {
        recipeScript.remove();
    }
};

export {
    jsonSchemaProduct,
    jsonSchemaProductRemove,
}
